import { OrganizationPersonOrder } from 'Apollo';
import { useColumnsOrganizationUsers } from 'Hooks/useColumnsOrganizationUsers';
import useTranslate from 'Hooks/useTranslate';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import LocalStorage from 'Tools/localStorage';
import UsersTableBase, { UsersTableBaseProps } from './UsersTableBase';

type OrganizationUsersTableProps = Omit<
  UsersTableBaseProps<OrganizationPersonOrder>,
  | 'activeColumns'
  | 'onChangeColumns'
  | 'onResetColumns'
  | 'toolbarLeftContent'
  | 'canDeleteUsers'
  | 'canSubscribeUsers'
  | 'canInviteUsers'
  | 'scope'
> & {
  organizationCode: string;
};

function OrganizationUsersTable(props: Readonly<OrganizationUsersTableProps>) {
  const defaultOrgColumns = useColumnsOrganizationUsers();
  const ts = useTranslate();
  const [orgColumns, setOrgColumns] = useState(
    LocalStorage.deserializeColumns(
      defaultOrgColumns,
      LocalStorage.OrganizationUsersColumns ?? []
    )
  );

  const onChangeColumns = (newColumns: any) => {
    setOrgColumns(newColumns);
    LocalStorage.OrganizationUsersColumns = LocalStorage.serializeColumns(newColumns);
  };

  const onResetColumns = () => {
    LocalStorage.OrganizationUsersColumns = null;
    setOrgColumns(defaultOrgColumns);
  };

  return (
    <>
      <Helmet title={ts('page.organizations.title')} />
      <UsersTableBase
        {...props}
        activeColumns={orgColumns}
        onChangeColumns={onChangeColumns}
        onResetColumns={onResetColumns}
        canDeleteUsers={true}
        canSubscribeUsers={false}
        canInviteUsers={false}
        scope={{ kind: 'organization', organizationCode: props.organizationCode }}
      />
    </>
  );
}

export default OrganizationUsersTable;
